import { render, staticRenderFns } from "./Companysettings.vue?vue&type=template&id=4b751568&scoped=true&"
import script from "./Companysettings.vue?vue&type=script&lang=js&"
export * from "./Companysettings.vue?vue&type=script&lang=js&"
import style0 from "./Companysettings.vue?vue&type=style&index=0&id=4b751568&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b751568",
  null
  
)

export default component.exports